export const INSIGHT_REPORTER_CONFIG = {
    NAME: 'AI分析レポート',
    TERMS_AND_CONDITIONS: {
        NAME: 'ai_usage_terms_and_conditions',
        LATEST_VERSION: '1.0.0', // 最新の利用規約バージョン
        MINIMUM_VERSION: '1.0.0' // 機能提供にあたって最低限同意が必要なバージョン
    },
    MAX_IMPORT_FILE: 50,
    MAX_COUNT: 50,
} as const;

export const INSIGHT_REPORTER_LINKS = {
    ADDON: `https://www.ricoh.co.jp/-/Media/Ricoh/Sites/co_jp/products/terms-and-conditions/service/RICOH-eWhiteboard-Add-on-Service-terms-of-use.pdf`,
    TERMS: `https://manuals.ricoh.com/e-whiteboard/manual/InsightReporter/terms${INSIGHT_REPORTER_CONFIG.TERMS_AND_CONDITIONS.LATEST_VERSION}.html`,
    MANUAL: 'https://manuals.ricoh.com/e-whiteboard/manual/InsightReporter/manual.html',
    INFORMATION: 'https://manuals.ricoh.com/e-whiteboard/manual/InsightReporter/information.html',
} as const;